<template>
    

  <div class="row">
    <h3>{{$t('requestforration_list')}}</h3>
    <loading :loadingText="`${$t('loading')}`" id="loadMe" :loadinSubText="`${$t('please_wait')}`"></loading>
  
      <!-- Modal -->
  <div class="modal fade" id="bsModal" tabindex="-1" role="dialog" aria-labelledby="bsModalLabel" data-toggle="modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="bsModalLabel">{{$t('requestforration_form')}}</h4>
        </div>
        <div class="modal-body">
               <form action="">
                 
               	<div class="form-group">
<input type="text"  v-model="form.contactNumber" name="contactNumber"  class="form-control my-input" id="contactNumber" :placeholder="`${$t('contactNumber')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.name" name="name"  class="form-control my-input" id="name" :placeholder="`${$t('name')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.idNumber" name="idNumber"  class="form-control my-input" id="idNumber" :placeholder="`${$t('idNumber')}`">
</div>
	<div class="form-group col-md-6">
<input type="text"  v-model="form.age" name="age"  class="form-control my-input" id="age" :placeholder="`${$t('age')}`" @input="$emit('input', $event)">
</div>
	<div class="form-group col-md-6">
<input type="text"  v-model="form.yob" name="yob"  class="form-control my-input" id="yob" :placeholder="`${$t('yob')}`" @input ="$emit('input', $event)">
</div>
	<div class="form-group">
<select v-model="form.gender" class="form-control">
                  <option value="">{{$t('gender')}}</option>
                 <option v-for="(s, i) in $t('sex')" :key="i" :value="i">
                           {{s}}
                          </option>
                </select>
</div>
	<div class="form-group">
<input type="text"  v-model="form.address" name="address"  class="form-control my-input" id="address" :placeholder="`${$t('address')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.city" name="city"  class="form-control my-input" id="city" :placeholder="`${$t('city')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.state" name="state"  class="form-control my-input" id="state" :placeholder="`${$t('state')}`">
</div>

	<div class="form-group">
<input type="text"  v-model="form.zipcode" name="zipcode"  class="form-control my-input" id="zipcode" :placeholder="`${$t('zipcode')}`">
</div>
                 
                  
                  <div v-if="loading">
                      <i class="fa fa-spin fa-spinner fa-3x"></i>
                  </div>   
                  <div class="text-center" v-else>
                     <button type="button" class="btn btn-success " @click="submit">{{$t('submit')}}</button>
                  </div>
                
                  <div class="alert alert-danger padding5" v-if="error.length>0">

                        <p v-for="(s, i) in error" :key="i">
                           
                            
                            {{$t(s)}}
                           
                        </p>
                  </div>
               
               </form>
        </div>
        <div class="modal-footer">
          
        </div>
      </div>
    </div>
  </div>
   
        <div class="box">
          <div class="box-header">
            
            <button class="btn btn-primary pull-right" @click="openFrom">{{$t('add_new')}}</button>
            
          </div>
           
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
       
          <div class="input-group">
            
<input type="text"  v-model="search.contactNumber" name="contactNumber"  class="input-group-text" :placeholder="`${$t('contactNumber')}`">


<input type="text"  v-model="search.name" name="name"  class="input-group-text" :placeholder="`${$t('name')}`">
<input type="text"  v-model="search.idNumber" name="idNumber"  class="input-group-text" :placeholder="`${$t('idNumber')}`">
<input type="text"  v-model="search.yob1" name="yob1"  class="input-group-text" :placeholder="`${$t('ageMin')}`">
<input type="text"  v-model="search.yob2" name="yob2"  class="input-group-text" :placeholder="`${$t('ageMax')}`">
<select v-model="search.gender" class="input-group-select">
                  <option value="">{{$t('gender')}}</option>
                 <option v-for="(s, i) in $t('sex')" :key="i" :value="i">
                           {{s}}
                          </option>
                </select>
<input type="text"  v-model="search.address" name="address"  class="input-group-text" :placeholder="`${$t('address')}`">
<input type="text"  v-model="search.city" name="city"  class="input-group-text" :placeholder="`${$t('city')}`">
<input type="text"  v-model="search.zipcode" name="zipcode"  class="input-group-text" :placeholder="`${$t('zipcode')}`">



      <select v-model="search.status" class="input-group-select" :placeholder="`${$t('statusLbl')}`"> 
       <option  value="">{{$t('statusLbl')}}</option>              
       <option v-for="(s, i) in $t('rationRequestStatus')" :key="i" :value="i">
          {{s}}
          </option>
      </select>
      

                
            <span class="pull-right">
             <button class='btn btn-sm btn-success padding5' @click="searchClick">{{$t('search')}}</button>
              <button class='btn btn-sm btn-success padding5' @click="clearClick">{{$t('clear')}}</button>
              </span>
          </div>
       
            <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th style="width: 10px">#</th>
                            	<th>{{$t('contactNumber')}}</th>
	<th>{{$t('name')}}</th>
	<th>{{$t('idNumber')}}</th>
	<th>{{$t('age')}}</th>
	<th>{{$t('gender')}}</th>
	<th>{{$t('address')}}</th>
	<th>{{$t('city')}}</th>
	<th>{{$t('state')}}</th>
	<th>{{$t('zipcode')}}</th>
	<th>{{$t('insertTime')}}</th>
	<th>{{$t('status')}}</th>
                            <th>{{ $t('action') }} </th>
                        </tr>
                        <tr v-for="requestforration in requestforrations" :key="requestforration.id">
                            <td></td>
                            	<td>
{{requestforration.contactNumber}}
</td>
	<td>
{{requestforration.name}}
</td>
	<td>
{{requestforration.idNumber}}
</td>
	<td>
{{currentYear - requestforration.yob}} 
</td>
	<td>
{{ $t('sex')[[requestforration.gender]] }}
	<td>
{{requestforration.address}}
</td>
	<td>
{{requestforration.city}}
</td>
	<td>
{{requestforration.state}}
</td>

	<td>
{{requestforration.zipcode}}
</td>
	<td>

        {{ moment(requestforration.insertTime).startOf('hour').fromNow()   }}
        
</td>
	<td>

      {{ $t('rationRequestStatus')[[requestforration.status]] }}
      
</td>
                        <td><a href="#" @click="openFrom(requestforration)"><i class="fa fa-edit fa-2x"></i></a></td>
                    </tr>
            </tbody>
            </table>
            <div class="card-footer pb-0 pt-3">
            <simple-pagination :currentpage="search.page" :pages="search.totalpages" @changePage="pageChange"></simple-pagination>
           </div>
        </div>
    </div>
 </div>

</template>

<script>
import { services } from '../../src/vuex/api'
import { mapActions , mapGetters } from 'vuex'
import simplePagination from '../../src/components/simple-pagination'
import VALoading  from '../../src/widgets/VALoading'
import { listError } from '../../src/lib/functions'
export default {
  name: 'RequestForRation',
   mounted: function () {
      var self = this
      let uri = window.location.href.split('?')
      if (uri.length === 2){
      let vars = uri[1].split('&')
      let getVars = {}
      let tmp = ''
      vars.forEach(function(v){
        tmp = v.split('=')
        if ( tmp.length === 2 ) {
          getVars[tmp[0]] = tmp[1]
          if ( tmp[0] in self.form ){
            self.form[tmp[0]] = tmp[1]
           }
         }
       })
      }
      this.getRequestForRation(self.form)
      this.getLanguage()
      if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
      this.$on('input', (event) => {
      if (event.target.name === 'age'){
          self.form.yob = this.currentYear - parseInt(event.target.value )
          this.updateYoB()
      }
    })
    },
    data: function () {
      return {
        currentYear : new Date().getFullYear(),
        loading:false,
        message: 'RequestForRation list',
        error:[],
        requestforrations: [],
        form: {
        contactNumber:'',
        name:'',
        idNumber:'',
        yob:-1,
        gender:0,
        address:'',
        city:'',
        state:'',
        locationName:'',
        zipcode:'',
        age:null
        },
        search:{
          contactNumber:'',
name:'',
idNumber:'',
yob1:null,
yob2:null,
gender:null,
address:'',
city:'',
locationName:'',
zipcode:'',
insertTime:null,
status:null,
          totalpages:0,
          page:0

        },
        customLabels:{
          first: '<<',
          last: '>>',
          previous: '<',
          next: '>'
        },
        listError
      }
    },
    components: {
    'simple-pagination': simplePagination,
     'loading': VALoading
     },
    methods: 
 
    {
       ...mapActions([
      'getLanguage'

    ]
       ),
    
  getRequestForRation: function ( request = {} ) {
    var self = this
    // self.loading = true 
     $('#loadMe').modal('show')
     services.RequestForRation.getRequestForRation(request) 
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.requestforrations = response.data.docs
      self.search.totalpages = Math.ceil( response.data.count / response.data.perpage )
      self.search.page = response.data.page
      // self.loading = false 
      $('#loadMe').modal('hide')
    })
    .catch(function (error) {
      console.log(error)
    })
  },
  addRequestForRation: function ( request = {} ) {
    var self = this
     self.loading = true 
     services.RequestForRation.addRequestForRation(request) //  .getPatientInfo()
    .then(function (response) {
      self.loading = false 
    $('#bsModal').modal('hide')
    $('#loadMe').modal('show')
     self.getRequestForRation({})
    })
    .catch(function (err) {
     self.loading = false 
     self.error = listError(err.response.data)
    })
  },
 updateRequestForRation: function ( request = {} ) {
    var self = this
     self.loading = true 
     services.RequestForRation.updateRequestForRation(request) //  .getPatientInfo()
    .then(function (response) {
      self.loading = false 
    $('#bsModal').modal('hide')
    $('#loadMe').modal('show')
     self.getRequestForRation({})
    })
    .catch(function (err) {
      self.loading = false 
     self.error = listError(err.response.data)
    })
  },
updateYoB:function(){
 this.form.yob = this.currentYear - parseInt( this.form.age )
},
updateAge:function(){
 this.form.age = this.currentYear - parseInt( this.form.yob )
},
submit:function() {
  if (this.form._id){
    this.form.age = this.currentYear - this.form.yob 
    this.updateRequestForRation(this.form)
  } else {
     this.addRequestForRation(this.form)
  }
},
  searchClick: function (){
    this.getRequestForRation(this.search)
  },
  clearClick: function (){
    var self = this // you need this because *this* will refer to Object.keys below
        // Iterate through each object field, key is name of the object field
      Object.keys(this.form).forEach(function(key,index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page'){
          self.search[key] = ''
        }
      })
  },
  pageChange: function (pageNo) {
    var self = this
    self.search.page = pageNo
    this.getRequestForRation(this.search)
  },
  openFrom:function(data){
    this.error = '' 
    if (data){
      this.form = data
    }
    $('#bsModal').modal('show')
  },
},
 computed: {
    ...mapGetters([
      'lang'
    ])
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.users-list-row{
  margin: 10px;
  padding: 10px;
}
.input-group{
  width: 100%;
  padding: 20px;
}
.input-group-text,.input-group-select{
  width: 8%;
  margin-left: 5px;
}
.input-group-text-small{
 width: 6%;
}
.inlineDiv{
 display: inline;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>

    
    


// WEBPACK FOOTER //
// RequestForRation.vue?d01e90f0